import React, { useState } from 'react';
import { Button, List, Modal, Spin } from 'antd';
import { PlusOutlined, DeleteOutlined, MessageOutlined } from '@ant-design/icons';
import './SessionSidebar.css';

interface Session {
  id: number;
  session_id: string;
  title: string;
  created_at: string;
  updated_at: string;
}

interface SessionSidebarProps {
  sessions: Session[];
  currentSessionId: string | null;
  loading: boolean;
  onCreateSession: () => void;
  onSelectSession: (sessionId: string) => void;
  onDeleteSession: (sessionId: string) => void;
}

const SessionSidebar: React.FC<SessionSidebarProps> = ({
  sessions,
  currentSessionId,
  loading,
  onCreateSession,
  onSelectSession,
  onDeleteSession
}) => {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [sessionToDelete, setSessionToDelete] = useState<string | null>(null);

  const handleDeleteClick = (sessionId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setSessionToDelete(sessionId);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = () => {
    if (sessionToDelete) {
      onDeleteSession(sessionToDelete);
      setDeleteModalVisible(false);
      setSessionToDelete(null);
    }
  };

  return (
    <div className="session-sidebar">
      {/* 顶部操作栏 */}
      <div className="sidebar-header">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreateSession}
          block
          style={{ marginBottom: '8px' }}
        >
          New Chat
        </Button>
      </div>

      {/* 会话列表 */}
      <div className="sidebar-content">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spin />
          </div>
        ) : (
          <List
            dataSource={sessions}
            renderItem={(session) => (
              <div
                key={session.session_id}
                className={`session-item ${session.session_id === currentSessionId ? 'active' : ''}`}
                onClick={() => onSelectSession(session.session_id)}
              >
                <div className="session-item-content">
                  <MessageOutlined className="session-icon" />
                  <span className="session-title">{session.title}</span>
                </div>
                <Button
                  type="text"
                  size="small"
                  icon={<DeleteOutlined />}
                  className="delete-btn"
                  onClick={(e) => handleDeleteClick(session.session_id, e)}
                />
              </div>
            )}
          />
        )}
      </div>

      {/* 删除确认对话框 */}
      <Modal
        title="删除对话"
        open={deleteModalVisible}
        onOk={handleConfirmDelete}
        onCancel={() => setDeleteModalVisible(false)}
        okText="确认删除"
        cancelText="取消"
        okButtonProps={{ danger: true }}
      >
        <p>确定要删除这个对话吗？此操作无法撤销。</p>
      </Modal>
    </div>
  );
};

export default SessionSidebar;
